export default __webpack_public_path__ + "static/media/783e00dc26e3fa59.7f92f28e64919ca99833063f0aeb024d.svg";